import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger, CustomEase);

window.Webflow ||= [];
window.Webflow.push(() => {
  // Videos special function
  function manageVideoSources() {
    var videoElement = document.getElementById('hero-video');

    while (videoElement.firstChild) {
      videoElement.removeChild(videoElement.firstChild);
    }

    if (window.innerWidth > 768) {
      var sourceMP4 = document.createElement('source');
      sourceMP4.setAttribute(
        'src',
        'https://trackable.sfo3.cdn.digitaloceanspaces.com/Trackable.mp4'
      );
      sourceMP4.setAttribute('type', 'video/mp4');

      var sourceWEBM = document.createElement('source');
      sourceWEBM.setAttribute(
        'src',
        'https://trackable.sfo3.cdn.digitaloceanspaces.com/Trackable.webm'
      );
      sourceWEBM.setAttribute('type', 'video/webm');

      videoElement.appendChild(sourceMP4);
      videoElement.appendChild(sourceWEBM);

      videoElement.load();
    }
  }

  manageVideoSources();

  window.addEventListener('resize', manageVideoSources);

  // Intercome widget
  var intercomeButtons = document.querySelectorAll('[wide-action="intercom"]');
  intercomeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (window.Intercom) {
        window.Intercom('show');
      } else {
        loadIntercom();
      }
    });
  });
  function loadIntercom() {
    window.intercomSettings = {
      app_id: 'm8f1sces',
    };
    var d = document;
    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://widget.intercom.io/widget/m8f1sces';
    s.onload = function () {
      window.Intercom('boot', window.intercomSettings);
      window.Intercom('show');
    };
    var x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }

  // Hero entry animation
  const heroAnimation = gsap.timeline({ paused: true });
  heroAnimation.from('.navbar', { top: '-100%', autoAlpha: 0, duration: 0.6, ease: 'power1.out' });
  heroAnimation.from(
    '.hero_background-shape-wrapper',
    {
      autoAlpha: 0,
      duration: 1.2,
      ease: CustomEase.create('custom', 'M0,0,C1,0,0.858,0.832,1,1'),
    },
    '<'
  );
  heroAnimation.from(
    '.hero_copy-wrapper h1',
    {
      y: '100px',
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<'
  );
  heroAnimation.from(
    '.hero_copy-wrapper p',
    {
      y: '100px',
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<0.2'
  );
  heroAnimation.from(
    '.hero_buttons-wrapper',
    {
      y: '100px',
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<0.2'
  );
  heroAnimation.from(
    '.hero_video',
    {
      y: '100px',
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<0.2'
  );
  window.onload = function () {
    heroAnimation.play();
  };

  // CTA animation
  const ctaAnimation = gsap.timeline({
    scrollTrigger: {
      trigger: '.section.is-cta',
      start: 'top 88%',
    },
  });
  ctaAnimation.from('.cta_copy-wrapper h2', {
    y: '100px',
    autoAlpha: 0,
    duration: 0.8,
    ease: 'power1.out',
  });
  ctaAnimation.from(
    '.cta_background-shape-wrapper',
    {
      autoAlpha: 0,
      duration: 0.8,
      ease: CustomEase.create('custom', 'M0,0,C1,0,0.858,0.832,1,1'),
    },
    '<'
  );
  ctaAnimation.from(
    '.cta_illu-screen',
    {
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<'
  );
  ctaAnimation.from(
    '.cta_copy-wrapper p',
    {
      y: '100px',
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<0.2'
  );
  ctaAnimation.from(
    '.cta_illu-ract',
    {
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<'
  );
  ctaAnimation.from(
    '.cta_buttons-wrapper',
    {
      y: '100px',
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power1.out',
    },
    '<0.2'
  );

  // Sections in animation
  function sectionAnimation(target) {
    gsap.from(target, {
      scrollTrigger: {
        trigger: target,
        start: 'top 88%',
      },
      y: '100px',
      autoAlpha: 0,
      duration: 0.4,
      ease: 'power1.out',
    });
  }
  sectionAnimation('.section.is-integrating');
  const featureSections = document.querySelectorAll('.section.is-feature');
  featureSections.forEach((section) => {
    sectionAnimation(section);
  });

  // Mirror click on form submit
  function triggerClickOnTarget() {
    const targetElement = document.querySelector('[wide="submit"]');
    if (targetElement) {
      targetElement.click();
    }
  }
  const triggerElement = document.querySelector('[wide="custom-submit"]');
  if (triggerElement) {
    triggerElement.addEventListener('click', triggerClickOnTarget);
  }

  // Modal opening animation
  const popupOpen = gsap.timeline({ paused: true });
  gsap.set('section.is-popup', { autoAlpha: 0, display: 'none' });
  popupOpen.to('section.is-popup', {
    display: 'flex',
    duration: 0.05,
  });
  popupOpen.to(
    'section.is-popup',
    {
      autoAlpha: 1,
      duration: 0.4,
      ease: 'power1.out',
    },
    '>'
  );

  // Open modal on click
  const popupOpenButtons = document.querySelectorAll('[wide-action="open-popup"]');
  popupOpenButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      popupOpen.play();
    });
  });
  const popupCloseButtons = document.querySelectorAll('[wide-action="close-popup"]');
  popupCloseButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      popupOpen.timeScale(2).reverse();
    });
  });

  // After form submited aciton
  const targetElement = document.querySelector('.w-form-done');
  function logSubmit(event) {
    event.preventDefault();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style') {
          const currentDisplayStyle = window.getComputedStyle(mutation.target).display;
          if (mutation.target.oldDisplay !== currentDisplayStyle) {
            if (currentDisplayStyle !== 'none') {
              setTimeout(function () {
                popupOpen.timeScale(2).reverse();
                function updatePopupBtnsLabels() {
                  const elements = document.querySelectorAll('[wide-element="join-label"]');
                  elements.forEach((element) => {
                    element.innerText = 'You joined!';
                  });
                }
                updatePopupBtnsLabels();
              }, 4000);
            }
          }
        }
      });
    });
    const config = {
      attributes: true,
      attributeFilter: ['style'],
    };
    targetElement.oldDisplay = window.getComputedStyle(targetElement).display;
    observer.observe(targetElement, config);
  }
  const form = document.getElementById('wf-form-Waitlist-Form');
  form.addEventListener('submit', logSubmit);
});
